<template>
    <div class="cardmian" @click="details">
        <card_state :CardData="props.CardData" :typedata="props.typedata" :index="props.index" :stateindex="state"
            :listitem="props.listitem" />
    </div>
</template>
<script setup lang="ts">
import { ref, defineProps, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import card_state from './card_state.vue'
const router = useRouter()
const route = useRoute()
const state = ref<any>('')

const props = defineProps({
    CardData: {
        type: Array,
        default: () => []
    },
    typedata: {
        type: [Array<any>, String, Number, Object],
        default: () => []
    },
    index: {
        type: [String, Number],
        default: ''
    },
    listitem: {
        type: [Object, Array],

    }
})
// 获取类型
state.value = props.typedata?.length > 1 ? props.typedata.length : props.typedata[0]
</script>
<style  lang="less" scoped>
.cardmian {
    // width: 100%;
    // height: 100%;
    aspect-ratio: 16 / 9;
}
</style>